import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { apiClient } from '../services/api'
import { useTranslation } from '../contexts/TranslationContext'

export default function VerifyEmail() {
  const { id, hash } = useParams()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [status, setStatus] = useState(t('Verifying...', 'Verifying...'))

  useEffect(() => {
    const verify = async () => {
      try {
        const response = await apiClient.get(`/auth/email/verify/${id}/${hash}`)
        setStatus(response.data.message || 'Email verified successfully')

        const savedRedirect = localStorage.getItem('post_verify_redirect') || response.data.redirect || '/'
        localStorage.removeItem('post_verify_redirect')

        setTimeout(() => {
          navigate(savedRedirect)
        }, 1500)
      } catch (error) {
        setStatus(error.response?.data?.message || 'Verification failed')
        setTimeout(() => {
          navigate('/login')
        }, 1500)
      }
    }

    verify()
  }, [id, hash, navigate])

  return (
    <div className="min-h-screen bg-surface-elevated flex items-center justify-center p-4">
      <div className="bg-surface p-8 rounded-lg shadow-lg text-center max-w-sm">
        <h1 className="text-xl font-bold mb-4">{t('Email Verification', 'Email Verification')}</h1>
        <p>{status}</p>
      </div>
    </div>
  )
}

